"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataPair = exports.DATA_PAIR_STYLE_TYPE = exports.DATA_PAIR_MARGIN_BOTTOM = exports.DATA_PAIR_LABEL_WIDTH = exports.DATA_PAIR_DIRECTION = exports.DATA_PAIR_BREAKPOINT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./DataPair.scss");
let DATA_PAIR_BREAKPOINT = exports.DATA_PAIR_BREAKPOINT = /*#__PURE__*/function (DATA_PAIR_BREAKPOINT) {
  DATA_PAIR_BREAKPOINT["none"] = "none";
  DATA_PAIR_BREAKPOINT["xs"] = "xs";
  DATA_PAIR_BREAKPOINT["sm"] = "sm";
  DATA_PAIR_BREAKPOINT["md"] = "md";
  DATA_PAIR_BREAKPOINT["lg"] = "lg";
  DATA_PAIR_BREAKPOINT["xl"] = "xl";
  return DATA_PAIR_BREAKPOINT;
}({});
let DATA_PAIR_DIRECTION = exports.DATA_PAIR_DIRECTION = /*#__PURE__*/function (DATA_PAIR_DIRECTION) {
  DATA_PAIR_DIRECTION["column"] = "column";
  DATA_PAIR_DIRECTION["row"] = "row";
  return DATA_PAIR_DIRECTION;
}({});
let DATA_PAIR_MARGIN_BOTTOM = exports.DATA_PAIR_MARGIN_BOTTOM = /*#__PURE__*/function (DATA_PAIR_MARGIN_BOTTOM) {
  DATA_PAIR_MARGIN_BOTTOM["small"] = "small";
  DATA_PAIR_MARGIN_BOTTOM["medium"] = "medium";
  DATA_PAIR_MARGIN_BOTTOM["large"] = "large";
  return DATA_PAIR_MARGIN_BOTTOM;
}({});
let DATA_PAIR_STYLE_TYPE = exports.DATA_PAIR_STYLE_TYPE = /*#__PURE__*/function (DATA_PAIR_STYLE_TYPE) {
  DATA_PAIR_STYLE_TYPE["default"] = "default";
  DATA_PAIR_STYLE_TYPE["small"] = "small";
  return DATA_PAIR_STYLE_TYPE;
}({});
let DATA_PAIR_LABEL_WIDTH = exports.DATA_PAIR_LABEL_WIDTH = /*#__PURE__*/function (DATA_PAIR_LABEL_WIDTH) {
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width10"] = 10] = "width10";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width15"] = 15] = "width15";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width20"] = 20] = "width20";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width25"] = 25] = "width25";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width30"] = 30] = "width30";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width33"] = 33] = "width33";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width35"] = 35] = "width35";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width40"] = 40] = "width40";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width45"] = 45] = "width45";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width50"] = 50] = "width50";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width55"] = 55] = "width55";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width60"] = 60] = "width60";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width65"] = 65] = "width65";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width66"] = 66] = "width66";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width70"] = 70] = "width70";
  DATA_PAIR_LABEL_WIDTH[DATA_PAIR_LABEL_WIDTH["width75"] = 75] = "width75";
  return DATA_PAIR_LABEL_WIDTH;
}({});
const DataPair = _ref => {
  let {
    children,
    className,
    labelClassName,
    valueClassName,
    label,
    breakpoint = DATA_PAIR_BREAKPOINT.none,
    direction = DATA_PAIR_DIRECTION.row,
    isColonDisplayed = true,
    labelWidth = DATA_PAIR_LABEL_WIDTH.width50,
    styleType = DATA_PAIR_STYLE_TYPE.default,
    labelDataAttributes,
    valueDataAttributes
  } = _ref;
  const marginBottom = direction === DATA_PAIR_DIRECTION.column ? DATA_PAIR_MARGIN_BOTTOM.large : styleType === DATA_PAIR_STYLE_TYPE.default ? DATA_PAIR_MARGIN_BOTTOM.medium : DATA_PAIR_MARGIN_BOTTOM.small;
  const rootClassName = (0, _classnames.default)('cds-DataPair', `cds-DataPair--${(0, _upperCase.upperCaseFirst)(direction || '')}`, {
    [`cds-DataPair--MobileBreakpoint${(0, _upperCase.upperCase)(breakpoint || '') || ''}`]: breakpoint !== DATA_PAIR_BREAKPOINT.none,
    [`cds-DataPair--${(0, _upperCase.upperCaseFirst)(styleType || '') || ''}`]: styleType !== DATA_PAIR_STYLE_TYPE.default,
    [`cds-DataPair--LabelWidth${labelWidth}`]: labelWidth !== DATA_PAIR_LABEL_WIDTH.width50,
    [`cds-DataPair--Margin${(0, _upperCase.upperCaseFirst)(marginBottom)}`]: true,
    [`cds-DataPair--DefaultDirection${(0, _upperCase.upperCaseFirst)(direction)}`]: true
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(labelDataAttributes), {
    className: (0, _classnames.default)('cds-DataPair-Label', labelClassName)
  }), label, isColonDisplayed && ':'), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(valueDataAttributes), {
    className: (0, _classnames.default)('cds-DataPair-Value', valueClassName)
  }), children));
};
exports.DataPair = DataPair;
//# sourceMappingURL=DataPair.js.map